
export interface Treatment {
  id: string;
  name: string;
  description: string;
  defaultPrice?: number;
  customPrice?: number;
  category: 'dental' | 'cosmetic';
  enabled?: boolean;
}

export const availableTreatments = {
  dental: [
    {
      id: 'dental-1',
      name: 'Teeth Cleaning',
      description: 'Professional dental cleaning to remove plaque and tartar',
      defaultPrice: 100,
      category: 'dental' as const
    },
    {
      id: 'dental-2',
      name: 'Dental Filling',
      description: 'Restore a tooth damaged by decay back to its normal function and shape',
      defaultPrice: 150,
      category: 'dental' as const
    },
    {
      id: 'dental-3',
      name: 'Root Canal',
      description: 'Endodontic treatment to remove infected pulp and save a tooth',
      defaultPrice: 800,
      category: 'dental' as const
    },
    {
      id: 'dental-4',
      name: 'Dental Crown',
      description: 'Custom-fitted covering that sits over a damaged tooth',
      defaultPrice: 1200,
      category: 'dental' as const
    },
    {
      id: 'dental-5',
      name: 'Dental Implant',
      description: 'Artificial tooth root to support restorations',
      defaultPrice: 3000,
      category: 'dental' as const
    },
    {
      id: 'dental-6',
      name: 'Teeth Whitening',
      description: 'Professional bleaching to remove discoloration',
      defaultPrice: 300,
      category: 'dental' as const
    },
    {
      id: 'dental-7',
      name: 'Dental Bridge',
      description: 'Fixed replacement for missing teeth',
      defaultPrice: 2500,
      category: 'dental' as const
    },
    {
      id: 'dental-8',
      name: 'Orthodontic Treatment',
      description: 'Correction of teeth and jaw alignment issues',
      defaultPrice: 5000,
      category: 'dental' as const
    }
  ],
  cosmetic: [
    {
      id: 'cosmetic-1',
      name: 'Botox',
      description: 'Injection to reduce facial wrinkles',
      defaultPrice: 400,
      category: 'cosmetic' as const
    },
    {
      id: 'cosmetic-2',
      name: 'Dermal Fillers',
      description: 'Gel-like substances injected beneath the skin',
      defaultPrice: 600,
      category: 'cosmetic' as const
    },
    {
      id: 'cosmetic-3',
      name: 'Rhinoplasty',
      description: 'Surgical procedure to change the shape of the nose',
      defaultPrice: 5000,
      category: 'cosmetic' as const
    },
    {
      id: 'cosmetic-4',
      name: 'Liposuction',
      description: 'Surgical removal of fat deposits',
      defaultPrice: 3500,
      category: 'cosmetic' as const
    },
    {
      id: 'cosmetic-5',
      name: 'Facelift',
      description: 'Surgical procedure to reduce the appearance of facial wrinkles',
      defaultPrice: 7500,
      category: 'cosmetic' as const
    },
    {
      id: 'cosmetic-6',
      name: 'Breast Augmentation',
      description: 'Surgical enhancement of breast size and shape',
      defaultPrice: 6000,
      category: 'cosmetic' as const
    },
    {
      id: 'cosmetic-7',
      name: 'Tummy Tuck',
      description: 'Surgical removal of excess abdominal skin and fat',
      defaultPrice: 6500,
      category: 'cosmetic' as const
    },
    {
      id: 'cosmetic-8',
      name: 'Chemical Peel',
      description: 'Application of chemical solution to improve and smooth skin texture',
      defaultPrice: 300,
      category: 'cosmetic' as const
    }
  ]
};
